var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.admin.equipment_order.title"),
          "icon-class": "mdi mdi-truck"
        }
      }),
      _vm._v(" "),
      _vm.notShippedOrdersPaginationData.data &&
      _vm.notShippedOrdersPaginationData.data.length
        ? _c("div", { staticClass: "card mb-4 shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("page-header", {
                  attrs: {
                    title: _vm.$t("pages.admin.equipment_order.not_shipped")
                  }
                }),
                _vm._v(" "),
                _c("static-loading-indicator-icon", {
                  attrs: { loading: _vm.$store.getters.shouldLoadLocal }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive" }, [
                  _c(
                    "table",
                    { staticClass: "table table-striped table-borderless" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.notShippedOrdersPaginationData.data,
                          function(order) {
                            return _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(order.user.first_name) +
                                    "\n                                " +
                                    _vm._s(order.user.last_name) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(order.user.phone_number) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      order.user.delivery_address[0].address_one
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      order.user.delivery_address[0].postal_code
                                    ) +
                                    ",\n                                " +
                                    _vm._s(
                                      order.user.delivery_address[0].city
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      order.user.delivery_address[0]
                                        .country_name
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm
                                        .$date(order.created_at)
                                        .format("DD.MM.YYYY")
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-info btn-sm float-right ",
                                    on: {
                                      click: function($event) {
                                        return _vm.sendEquipment(order.id)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "mdi mdi-truck" })]
                                )
                              ])
                            ])
                          }
                        ),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("pagination", {
                        attrs: { data: _vm.notShippedOrdersPaginationData },
                        on: {
                          "pagination-change-page":
                            _vm.getAllNotShippedEquipmentOrders
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ])
        : _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "alert alert-secondary border-dark shadow-sm" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("pages.admin.equipment_order.not_shipped_empty")
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
      _vm._v(" "),
      _vm.shippedOrdersPaginationData.data &&
      _vm.shippedOrdersPaginationData.data.length
        ? _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("page-header", {
                  attrs: {
                    title: _vm.$t("pages.admin.equipment_order.shipped")
                  }
                }),
                _vm._v(" "),
                _c("static-loading-indicator-icon", {
                  attrs: { loading: _vm.$store.getters.shouldLoadLocal }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive" }, [
                  _c(
                    "table",
                    { staticClass: "table table-striped table-borderless" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.shippedOrdersPaginationData.data, function(
                          order
                        ) {
                          return _c("tr", [
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(order.user.first_name) +
                                  "\n                                " +
                                  _vm._s(order.user.last_name) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(order.user.phone_number) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    order.user.delivery_address[0].address_one
                                  ) +
                                  "\n                                "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    order.user.delivery_address[0].postal_code
                                  ) +
                                  ",\n                                " +
                                  _vm._s(order.user.delivery_address[0].city) +
                                  "\n                                "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    order.user.delivery_address[0].country_name
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm
                                      .$date(order.created_at)
                                      .format("DD.MM.YYYY")
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm
                                        .$date(order.shipped_at)
                                        .format("DD.MM.YYYY")
                                    ) +
                                    "\n                                "
                                )
                              ])
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("pagination", {
                        attrs: { data: _vm.shippedOrdersPaginationData },
                        on: {
                          "pagination-change-page":
                            _vm.getAllShippedEquipmentOrders
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ])
        : _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "alert alert-secondary border-dark shadow-sm" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("pages.admin.equipment_order.shipped_empty")
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("User")]),
        _vm._v(" "),
        _c("th", [_vm._v("Phone Number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Address")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ordered")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("User")]),
        _vm._v(" "),
        _c("th", [_vm._v("Phone Number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Address")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ordered")]),
        _vm._v(" "),
        _c("th", [_vm._v("Shipped")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "badge badge-success" }, [
      _c("i", { staticClass: "mdi mdi-check" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }